import { render, staticRenderFns } from "./TaskFinished.vue?vue&type=template&id=9aaa70cc&scoped=true&"
import script from "./TaskFinished.vue?vue&type=script&lang=ts&"
export * from "./TaskFinished.vue?vue&type=script&lang=ts&"
import style0 from "./TaskFinished.vue?vue&type=style&index=0&id=9aaa70cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaa70cc",
  null
  
)

export default component.exports